function j(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function p(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function S(e) {
  return e && e.nodeType === Node.ELEMENT_NODE;
}
let m = (e) => {
  var t = {};
  return e && t.toString.call(e) === "[object Function]";
};
typeof /./ != "function" && typeof Int8Array != "object" && (f() || typeof document.childNodes != "function") && (m = function(e) {
  return typeof e == "function" || !1;
});
const F = (e) => e === void 0, N = (e) => e != null, P = (e, t) => {
  if (e.install = (n) => {
    for (const r of [e, ...Object.values(t != null ? t : {})])
      n.component(r.name, r);
  }, t)
    for (const [n, r] of Object.entries(t))
      e[n] = r;
  return e;
}, O = Object.prototype.hasOwnProperty;
function $() {
}
function x(e, t) {
  return O.call(e, t);
}
function A(e, t) {
  for (let n in t)
    e[n] = t[n];
  return e;
}
function M(e) {
  var t = {};
  for (let n = 0; n < e.length; n++)
    e[n] && A(t, e[n]);
  return t;
}
const q = function(e, t) {
  t = t || "";
  const n = t.split(".");
  let r = e, i = null;
  for (let o = 0, c = n.length; o < c; o++) {
    const s = n[o];
    if (!r)
      break;
    if (o === c - 1) {
      i = r[s];
      break;
    }
    r = r[s];
  }
  return i;
};
function T(e, t, n) {
  let r = e;
  t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
  let i = t.split("."), o = 0;
  for (let c = i.length; o < c - 1 && !(!r && !n); ++o) {
    let s = i[o];
    if (s in r)
      r = r[s];
    else {
      if (n)
        throw new Error("please transfer a valid prop path to form item!");
      break;
    }
  }
  return {
    o: r,
    k: i[o],
    v: r ? r[i[o]] : null
  };
}
const I = function() {
  return Math.floor(Math.random() * 1e4);
}, C = (e, t) => {
  if (e === t)
    return !0;
  if (!(e instanceof Array) || !(t instanceof Array) || e.length !== t.length)
    return !1;
  for (let n = 0; n !== e.length; ++n)
    if (e[n] !== t[n])
      return !1;
  return !0;
}, R = (e = "") => String(e).replace(/[|\\{}()[\]^$+*?.]/g, "\\$&"), E = function(e, t) {
  for (let n = 0; n !== e.length; ++n)
    if (t(e[n]))
      return n;
  return -1;
}, z = function(e, t) {
  const n = E(e, t);
  return n !== -1 ? e[n] : void 0;
}, D = function(e) {
  return Array.isArray(e) ? e : e ? [e] : [];
}, J = function() {
  return !f() && !isNaN(Number(document.documentMode));
}, L = function() {
  return !f() && navigator.userAgent.indexOf("Edge") > -1;
}, U = function() {
  return !f() && !!window.navigator.userAgent.match(/firefox/i);
}, V = function(e) {
  const t = ["transform", "transition", "animation"], n = ["ms-", "webkit-"];
  return t.forEach((r) => {
    const i = e[r];
    r && i && n.forEach((o) => {
      e[o + r] = i;
    });
  }), e;
}, W = function(e) {
  const t = /([^-])([A-Z])/g;
  return e.replace(t, "$1-$2").replace(t, "$1-$2").toLowerCase();
}, _ = function(e) {
  return j(e) ? e.charAt(0).toUpperCase() + e.slice(1) : e;
}, g = function(e, t) {
  const n = p(e), r = p(t);
  return n && r ? JSON.stringify(e) === JSON.stringify(t) : !n && !r ? String(e) === String(t) : !1;
}, w = function(e, t) {
  if (e = e || [], t = t || [], e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!g(e[n], t[n]))
      return !1;
  return !0;
}, B = function(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? w(e, t) : g(e, t);
}, k = function(e) {
  if (e == null)
    return !0;
  if (typeof e == "boolean")
    return !1;
  if (typeof e == "number")
    return !e;
  if (e instanceof Error)
    return e.message === "";
  switch (Object.prototype.toString.call(e)) {
    case "[object String]":
    case "[object Array]":
      return !e.length;
    case "[object File]":
    case "[object Map]":
    case "[object Set]":
      return !e.size;
    case "[object Object]":
      return !Object.keys(e).length;
  }
  return !1;
};
function H(e) {
  let t = !1;
  return function(...n) {
    t || (t = !0, window.requestAnimationFrame((r) => {
      e.apply(this, n), t = !1;
    }));
  };
}
function Z(e) {
  return Array.isArray(e) ? e : k(e) ? [] : [e];
}
function f() {
  return typeof window == "undefined";
}
function G(e, t, n, r) {
  const { openCaseMode: i, ignorePattern: o, replaceAll: c, keyPlaceholderWord: s } = r;
  let d = s || "[(key)]", a = "";
  c && (a += "g"), i || (a += "i");
  const y = new RegExp(t, a);
  let l = [], h = 0;
  return o && (e = e.replace(o, function(u) {
    return l.push(u), `<<${h++}>>`;
  })), e = e.replace(y, function(u) {
    return n.replaceAll(d, u);
  }), o && (e = e.replace(/<<(\d+)>>/g, function(u, b) {
    return l[b];
  })), e;
}
export {
  V as A,
  W as B,
  g as C,
  w as D,
  H as E,
  Z as F,
  J as a,
  L as b,
  I as c,
  B as d,
  R as e,
  k as f,
  q as g,
  D as h,
  f as i,
  F as j,
  _ as k,
  j as l,
  p as m,
  $ as n,
  S as o,
  m as p,
  N as q,
  G as r,
  x as s,
  M as t,
  T as u,
  C as v,
  P as w,
  E as x,
  z as y,
  U as z
};
